// src/services/planning.service.js
import axiosInstance from './axiosServicesVisit.js';

// --- AJOUT DU PRÉFIXE VERSION ---
const V1 = '/v1'; 

// --- Cycles ---
export const getCycles = (params) => axiosInstance.get(`${V1}/cycles`, { params });
export const addCycle = (cycleData) => axiosInstance.post(`${V1}/cycles`, cycleData);
export const getCycleById = (id) => axiosInstance.get(`${V1}/cycles/${id}`);
export const updateCycle = (id, cycleData) => axiosInstance.patch(`${V1}/cycles/${id}`, cycleData);
export const deleteCycle = (id) => axiosInstance.delete(`${V1}/cycles/${id}`);

export const importCyclesJSON = (cyclesData) => {
    const importUrl = `${V1}/cycles/import-json`;
    return axiosInstance.post(importUrl, cyclesData);
};

// --- Public Holidays ---
export const getPublicHolidays = () => axiosInstance.get(`${V1}/public-holidays`);
export const addPublicHoliday = (holidayData) => axiosInstance.post(`${V1}/public-holidays`, holidayData);
export const getPublicHolidayById = (id) => axiosInstance.get(`${V1}/public-holidays/${id}`);
export const updatePublicHoliday = (id, holidayData) => axiosInstance.patch(`${V1}/public-holidays/${id}`, holidayData);
export const deletePublicHoliday = (id) => axiosInstance.delete(`${V1}/public-holidays/${id}`);

// --- Delegate Leaves (CORRECTION ICI) ---
export const getDelegateLeaves = (params) => axiosInstance.get(`${V1}/delegate-leaves`, { params });
export const addDelegateLeave = (leaveData) => axiosInstance.post(`${V1}/delegate-leaves`, leaveData);
export const getDelegateLeaveById = (id) => axiosInstance.get(`${V1}/delegate-leaves/${id}`);
export const updateDelegateLeave = (id, leaveData) => axiosInstance.patch(`${V1}/delegate-leaves/${id}`, leaveData);
export const deleteDelegateLeave = (id) => axiosInstance.delete(`${V1}/delegate-leaves/${id}`);

// --- Service pour récupérer les délégués ---
// Attention, si /delegates est aussi versionné, il faut peut-être ajouter V1 ici aussi
export const getDelegatesForSelect = () => axiosInstance.get(`${V1}/delegates`, { params: { minimal: true } });

export const exportDelegateLeaves = (params) => {
  return axiosInstance.get(`${V1}/delegate-leaves/export/all`, {
    params,
    responseType: 'blob',
  });
};

export const checkDoctorAssignmentConflicts = (data) =>
  axiosInstance.post(`${V1}/cycles/check-conflicts`, data);

export const getAllDoctorConflicts = (params) =>
  axiosInstance.get(`${V1}/cycles/conflicts/all`, { params });